import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Payment } from 'packages/payment';
import { fetchAppsResource } from 'packages/apis';

import { buildStudySelector } from '../../store/studies/selectors';
import { updateStatusSuccessAction } from '../../store/studies/actions';

interface InvoiceData {
  totalBalance: number;
}
const InvoicesAndPayments = () => {
  const { studyId } = useParams();
  const selectStudy = buildStudySelector(studyId);
  const study = useSelector(selectStudy);
  const dispatch = useDispatch();
  const updateStudyStatus = (paid: boolean, paidTime = Date.now()) => {
    dispatch(
      updateStatusSuccessAction(studyId, {
        ...study.status,
        paid,
        paidTime,
      }),
    );
  };

  useEffect(() => {
    if (studyId) {
      fetchAppsResource<InvoiceData>(`/payment/study/${studyId}`).then(
        ({ parsedBody: data }) => data && updateStudyStatus(data.totalBalance === 0),
      );
    }
  }, [studyId]);

  return <Payment onChange={updateStudyStatus} shouldDisplayReconciliation />;
};

export default InvoicesAndPayments;
